import React from "react";
import "./BelowBanner.css";
import zkSyncIcon from "../../../assets/img/zkSync-icon.png";
import TrushIcon from "../../../assets/img/trush-icon.png";

const BelowBanner = () => {
  return (
    <section className="below-banner text-center">
      <div className="below-banner__powered-by">
        <span className="below-banner__powered-by__title">Powered By</span>
        <div className="icons mt-3 below-banner__powered-by__icons justify-center backed-by-section">          
          <svg width="192.5" height="67.5" viewBox="0 0 120 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M41.6539 13.4915L29.8378 1.71674V10.34L18.1055 18.9739L29.8378 18.982V25.2662L41.6539 13.4915Z" fill="#4E529A"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M-0.00158644 13.4872L11.8145 25.2619L11.8145 16.708L23.5469 8.0047L11.8145 7.99664L11.8145 1.71246L-0.00158644 13.4872Z" fill="#8C8DFC"></path><path d="M59.2586 19.3717H50.2148V16.7746L55.3922 11.0034H50.3482V8.45069H59.1697V10.9146L53.8368 16.7968H59.2586V19.3717Z" fill="#4E529A" fill-opacity="0.9"></path><path d="M71.6009 8.45069L67.2235 13.0455L71.6898 19.3717H68.0678L65.1792 15.1986L63.957 16.486V19.3717H61.0017V3.30096H63.957V12.5128L67.7345 8.45069H71.6009Z" fill="#4E529A" fill-opacity="0.9"></path><path d="M84.4547 7.38523L81.6994 8.22872C81.5957 7.66639 81.3142 7.15586 80.855 6.69712C80.3958 6.23838 79.7217 6.00901 78.8329 6.00901C78.1071 6.00901 77.5145 6.20878 77.0553 6.60833C76.5961 6.99308 76.3664 7.45922 76.3664 8.00675C76.3664 8.96862 76.9368 9.56054 78.0774 9.78251L80.2773 10.2043C81.6697 10.4706 82.7512 11.0255 83.5215 11.869C84.2918 12.7125 84.6769 13.704 84.6769 14.8434C84.6769 16.1457 84.1584 17.2851 83.1215 18.2618C82.0993 19.2237 80.7217 19.7046 78.9885 19.7046C77.996 19.7046 77.0997 19.5566 76.2998 19.2607C75.4998 18.9647 74.8554 18.5726 74.3666 18.0842C73.8777 17.5811 73.4926 17.0558 73.2111 16.5082C72.9445 15.9459 72.7815 15.3688 72.7223 14.7769L75.5665 14.0222C75.6406 14.8656 75.9665 15.5686 76.5442 16.1309C77.1368 16.6932 77.9589 16.9744 79.0107 16.9744C79.8106 16.9744 80.4328 16.7968 80.8772 16.4416C81.3364 16.0865 81.5661 15.6203 81.5661 15.0432C81.5661 14.5845 81.3957 14.1923 81.055 13.8668C80.7291 13.5264 80.2624 13.2971 79.6551 13.1787L77.4553 12.7347C76.1813 12.4684 75.1739 11.943 74.4333 11.1587C73.6926 10.3744 73.3222 9.39776 73.3222 8.22872C73.3222 6.8377 73.8555 5.66865 74.9221 4.72158C76.0035 3.7745 77.2997 3.30096 78.8107 3.30096C79.7143 3.30096 80.5217 3.42675 81.2327 3.67832C81.9438 3.92988 82.5141 4.27024 82.9437 4.69938C83.3733 5.11373 83.7066 5.54287 83.9437 5.98681C84.1807 6.43075 84.351 6.89689 84.4547 7.38523Z" fill="#4E529A" fill-opacity="0.9"></path><path d="M89.6555 23.6779H86.5224L89.1 17.9954L84.4559 8.45069H87.7668L90.6777 14.8434L93.3664 8.45069H96.5217L89.6555 23.6779Z" fill="#4E529A" fill-opacity="0.9"></path><path d="M100.601 13.0899V19.3717H97.6454V8.45069H100.512V9.80471C100.823 9.27198 101.267 8.86503 101.845 8.58387C102.423 8.30271 103.03 8.16213 103.667 8.16213C104.956 8.16213 105.934 8.56907 106.6 9.38297C107.282 10.1821 107.622 11.2179 107.622 12.4906V19.3717H104.667V13.0011C104.667 12.35 104.497 11.8246 104.156 11.4251C103.83 11.0255 103.326 10.8258 102.645 10.8258C102.023 10.8258 101.527 11.0403 101.156 11.4695C100.786 11.8986 100.601 12.4388 100.601 13.0899Z" fill="#4E529A" fill-opacity="0.9"></path><path d="M114.866 10.848C114.081 10.848 113.422 11.1217 112.888 11.6693C112.355 12.2168 112.088 12.9641 112.088 13.9112C112.088 14.8582 112.355 15.6129 112.888 16.1753C113.436 16.7228 114.103 16.9966 114.888 16.9966C115.584 16.9966 116.14 16.819 116.555 16.4638C116.97 16.0939 117.251 15.6573 117.399 15.1542L119.999 16.0199C119.732 17.0262 119.155 17.8918 118.266 18.617C117.377 19.3421 116.251 19.7046 114.888 19.7046C113.259 19.7046 111.888 19.1571 110.777 18.062C109.681 16.9522 109.133 15.5686 109.133 13.9112C109.133 12.239 109.674 10.8554 110.755 9.76032C111.851 8.66526 113.199 8.11773 114.799 8.11773C116.192 8.11773 117.332 8.48028 118.221 9.20539C119.11 9.9157 119.68 10.7814 119.932 11.8024L117.288 12.6903C116.932 11.4621 116.125 10.848 114.866 10.848Z" fill="#4E529A" fill-opacity="0.9"></path></svg>
        </div>
      </div>
      <div className="below-banner__contract">
        <span className="below-banner__contract__title">Contract</span>
        <div className="footer__token-address token-address mt-3">
          <img
            width={32}
            height={32}
            src={zkSyncIcon}
            className="token-address__network"
          />
          <span className="copiable">
            <span className="token-address__address">TBA</span>
            <svg
              width={16}
              height={16}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="token-address__copy"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.0568 1.33203H3.89034L3.88818 1.33203C3.21118 1.33404 2.56249 1.60386 2.08378 2.08256C1.60508 2.56127 1.33525 3.20996 1.33325 3.88695V10.0535L1.33325 10.0556C1.33501 10.6721 1.58071 11.2629 2.01666 11.6988C2.44263 12.1248 3.0164 12.3691 3.61758 12.3817C3.65645 13.6496 4.69647 14.6655 5.97376 14.6655H12.3094C13.6113 14.6655 14.6667 13.6101 14.6667 12.3082V5.97254C14.6667 4.69527 13.6508 3.65527 12.383 3.61637C12.3704 3.01518 12.1261 2.44141 11.7001 2.01544C11.2641 1.57948 10.6734 1.33379 10.0568 1.33203ZM10.9209 3.61523C10.9086 3.40217 10.8186 3.20034 10.6669 3.04866C10.5041 2.88591 10.2837 2.7941 10.0535 2.79322H3.89156C3.60094 2.79432 3.32252 2.91026 3.117 3.11577C2.91148 3.32129 2.79555 3.59971 2.79444 3.89032V10.0523C2.79533 10.2824 2.88714 10.5029 3.04988 10.6656C3.20157 10.8173 3.4034 10.9074 3.61646 10.9196V5.97254C3.61646 4.67064 4.67186 3.61523 5.97376 3.61523H10.9209ZM5.07764 5.97254C5.07764 5.47763 5.47885 5.07642 5.97376 5.07642H12.3094C12.8043 5.07642 13.2055 5.47763 13.2055 5.97254V12.3082C13.2055 12.8031 12.8043 13.2043 12.3094 13.2043H5.97376C5.47885 13.2043 5.07764 12.8031 5.07764 12.3082V5.97254Z"
                fill="white"
              />
            </svg>
          </span>
          <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="token-address__metamask"
          >
            <path
              d="M27.5303 3.56641L17.5366 10.9889L19.3847 6.60972L27.5303 3.56641Z"
              fill="#E2761B"
              stroke="#E2761B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.45935 3.56641L14.3727 11.0592L12.615 6.60972L4.45935 3.56641Z"
              fill="#E4761B"
              stroke="#E4761B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M23.9346 20.7715L21.2729 24.8493L26.9679 26.4162L28.605 20.8619L23.9346 20.7715Z"
              fill="#E4761B"
              stroke="#E4761B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.40479 20.8619L5.0319 26.4162L10.7268 24.8493L8.06517 20.7715L3.40479 20.8619Z"
              fill="#E4761B"
              stroke="#E4761B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.4053 13.882L8.81836 16.2825L14.4731 16.5336L14.2722 10.457L10.4053 13.882Z"
              fill="#E4761B"
              stroke="#E4761B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.5843 13.882L17.6672 10.3867L17.5366 16.5336L23.1813 16.2825L21.5843 13.882Z"
              fill="#E4761B"
              stroke="#E4761B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.7271 24.8496L14.1219 23.1924L11.1891 20.9023L10.7271 24.8496Z"
              fill="#E4761B"
              stroke="#E4761B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.8682 23.1924L21.2731 24.8496L20.801 20.9023L17.8682 23.1924Z"
              fill="#E4761B"
              stroke="#E4761B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.2731 24.8487L17.8682 23.1914L18.1394 25.4111L18.1092 26.3452L21.2731 24.8487Z"
              fill="#D7C1B3"
              stroke="#D7C1B3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.7271 24.8487L13.8909 26.3452L13.8708 25.4111L14.1219 23.1914L10.7271 24.8487Z"
              fill="#D7C1B3"
              stroke="#D7C1B3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.9408 19.4351L11.1084 18.6015L13.1071 17.6875L13.9408 19.4351Z"
              fill="#233447"
              stroke="#233447"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.0488 19.4351L18.8825 17.6875L20.8913 18.6015L18.0488 19.4351Z"
              fill="#233447"
              stroke="#233447"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.7271 24.8474L11.2092 20.7695L8.06543 20.8599L10.7271 24.8474Z"
              fill="#CD6116"
              stroke="#CD6116"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.791 20.7695L21.2731 24.8474L23.9348 20.8599L20.791 20.7695Z"
              fill="#CD6116"
              stroke="#CD6116"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M23.1818 16.2812L17.5371 16.5323L18.0594 19.435L18.893 17.6874L20.9018 18.6014L23.1818 16.2812Z"
              fill="#CD6116"
              stroke="#CD6116"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.1089 18.6014L13.1177 17.6874L13.9413 19.435L14.4736 16.5323L8.81885 16.2812L11.1089 18.6014Z"
              fill="#CD6116"
              stroke="#CD6116"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.81836 16.2812L11.1887 20.9015L11.1084 18.6014L8.81836 16.2812Z"
              fill="#E4751F"
              stroke="#E4751F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.9012 18.6014L20.8008 20.9015L23.1812 16.2812L20.9012 18.6014Z"
              fill="#E4751F"
              stroke="#E4751F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.4732 16.5312L13.9409 19.4339L14.6038 22.8589L14.7545 18.3492L14.4732 16.5312Z"
              fill="#E4751F"
              stroke="#E4751F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.5363 16.5312L17.2651 18.3392L17.3857 22.8589L18.0586 19.4339L17.5363 16.5312Z"
              fill="#E4751F"
              stroke="#E4751F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.0592 19.4352L17.3862 22.8602L17.8683 23.1917L20.8012 20.9016L20.9016 18.6016L18.0592 19.4352Z"
              fill="#F6851B"
              stroke="#F6851B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.1084 18.6016L11.1888 20.9016L14.1216 23.1917L14.6037 22.8602L13.9408 19.4352L11.1084 18.6016Z"
              fill="#F6851B"
              stroke="#F6851B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.1093 26.3442L18.1395 25.4101L17.8884 25.1892H14.1018L13.8708 25.4101L13.8909 26.3442L10.7271 24.8477L11.8319 25.7516L14.0717 27.3084H17.9185L20.1684 25.7516L21.2732 24.8477L18.1093 26.3442Z"
              fill="#C0AD9E"
              stroke="#C0AD9E"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.8681 23.1908L17.386 22.8594H14.6038L14.1217 23.1908L13.8706 25.4105L14.1016 25.1896H17.8882L18.1393 25.4105L17.8681 23.1908Z"
              fill="#161616"
              stroke="#161616"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M27.9523 11.471L28.806 7.37306L27.5304 3.56641L17.8682 10.7378L21.5844 13.8815L26.8374 15.4183L28.0025 14.0623L27.5003 13.7007L28.3038 12.9675L27.6811 12.4854L28.4846 11.8727L27.9523 11.471Z"
              fill="#763D16"
              stroke="#763D16"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.19385 7.37306L4.04758 11.471L3.50521 11.8727L4.30873 12.4854L3.69605 12.9675L4.49956 13.7007L3.99736 14.0623L5.15242 15.4183L10.4054 13.8815L14.1217 10.7378L4.45939 3.56641L3.19385 7.37306Z"
              fill="#763D16"
              stroke="#763D16"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M26.8372 15.4176L21.5842 13.8809L23.1812 16.2814L20.8008 20.9016L23.9345 20.8614H28.6049L26.8372 15.4176Z"
              fill="#F6851B"
              stroke="#F6851B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.4054 13.8809L5.15243 15.4176L3.40479 20.8614H8.06517L11.1888 20.9016L8.81847 16.2814L10.4054 13.8809Z"
              fill="#F6851B"
              stroke="#F6851B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.5368 16.5328L17.8682 10.7374L19.3949 6.60938H12.6152L14.1218 10.7374L14.4734 16.5328L14.5939 18.3608L14.6039 22.8605H17.3861L17.4062 18.3608L17.5368 16.5328Z"
              fill="#F6851B"
              stroke="#F6851B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default BelowBanner;
